import styled from 'styled-components';

export const StyledPagenation = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
  margin-right: 10px;

  .form-group {
    display: flex;
    width: 12rem;
    align-items: center;

    .form-label {
      margin-bottom: 0;
      margin-right: 5px;
    }

    .form-control {
      width: 4rem;
      padding: unset;
      margin-right: 10px;
    }
  }
`;
